import { NgRedux, select } from "@angular-redux/store";
import { Component, ElementRef, OnChanges, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { Observable, Subject } from "rxjs/Rx";

import { PoolService } from "../../../pool/pool.service";
import { LocationSelectorComponent } from "../../../shared/components/location-selector/location-selector.component";
import { AddressLocation } from "../../../shared/models/address-location";
import { ComponentSource, ModalType } from "../../../shared/models/component-source";
import { UpdatePlanningBlock } from "../../../shared/models/planning-block/update-planning-block.interface";
import { ON_HOLD, PLANNED, PlanningStatusDisplay, PRE_PLANNED, RE_USED, TO_BE_PLANNED } from "../../../shared/models/status-type.interface";
import { ActionBarService } from "../../../shared/services/action-bar.service";
import { ModalManagerService } from "../../../shared/services/modal-manager.service";
import { SharedService } from "../../../shared/services/shared.service";
import { SharedActions } from "../../../shared/shared.actions";
import { IAppState } from "../../../store/IAppState";
import { DepotOutActions } from "../../depot-out.actions";

import { CapacitySlot } from "../../../shared/models/capacity-slot.interface";
import { DepotCapacitySelectorComponent } from "../../../shared/containers/capacity-selector/capacity-selector.component";
import { PlanningBlock } from "../../../pb-screen/models/planning-block/planning-block.interface";
import { MsalService } from "../../../msal/msal.service";
import { IdNameAsStringObject } from "../../../pb-screen/models/quick-view/id-name-as-string-object.interface";
import { ContainerStatusId } from "../../../pb-screen/models/planning-block/planning-block-container-status.interface";
import { ApplicationUser } from "../../../pb-screen/models/application.user.interface";
import { SimpleModalComponent } from "ngx-simple-modal";
import { takeUntil } from "rxjs/operators";


@Component({
    selector: "depot-out-status-modal",
    templateUrl: "./depot-out-status-modal.component.html",
})

export class DepotOutStatusModalComponent extends SimpleModalComponent<void,void> implements OnChanges, OnInit , OnDestroy {
    @select("depotOutSelection") public depotOutSelection$: Observable<PlanningBlock[]>;
    @select("containerStatuses") public containerStatuses$: Observable<IdNameAsStringObject[]>;
    @select("depotInSelection") public depotInSelection$: Observable<PlanningBlock[]>;
    @select('applicationUser') applicationUser$: Observable<ApplicationUser>;
    @select('loading') public loading$: Observable<boolean>;
    @ViewChild(LocationSelectorComponent) public locationSelector: LocationSelectorComponent;
    @ViewChild(DepotCapacitySelectorComponent) private capacitySelector: DepotCapacitySelectorComponent;

    public enableAutocomplete: boolean = false;
    public selectedPlanningBlocks: PlanningBlock[] = [];
    public depotInSelection: PlanningBlock[] = [];
    public selectedLocation: AddressLocation;
    public selectedPbsStatus: string;
    public selectedStatus: IdNameAsStringObject;
    public componentSource = ComponentSource;
    public containerStatusId = ContainerStatusId;
    public statusOptions: IdNameAsStringObject[] = [];
    public containerStatuses: IdNameAsStringObject[] = [];
    public containerNumberIsValid: boolean = true;
    public containerNumberRequired: boolean = false;
    public containerNumber: string;
    public containerNumberErrorMessage: string;
    public buttonState: boolean = true;
    public depotInFrom: string;
    public depotInFromRequired: boolean = false;
    public commentEnabled: boolean = false;
    public ref1Enabled: boolean = false;
    public ref2Enabled: boolean = false;
    public statusEnabled: boolean = false;
    public commentValue: string = "";
    public ref1Value: string = "";
    public ref2Value: string = "";
    public updatedPlanningBlocks: PlanningBlock[] = [];
    public modalType = ModalType;
    public containerNumberFilled: boolean = false;
    public locationFilled: boolean = true;
    public loading = false;
    public enabled: boolean = false;
    public bookedFromValue: string = "";
    public bookedUntilValue: string = "";
    public containerIsAvailable: boolean = false;
    public warehouseRemark: string = "";
    public CONTAINER_NUMBER_LENGTH: number = 11;
    private selectedCapacity: CapacitySlot;
    private planDate: string;
    private readonly destroy$ = new Subject<void>();

    public selectedPlanningState : any;
    public planningStates: any[] = [PlanningStatusDisplay.onHold, PlanningStatusDisplay.toBePlanned];
    public allowPlanningStateChange: boolean = false;
    public userId: string = "";
    public locationWasUpdated = false;

    public emptyLocation: AddressLocation = {
        timestamp: "",
        addressId: "",
        locationCode: "",
        searchName: "",
        createdBy: "",
        creationDateTime: "",
        lastModifiedBy: "",
        lastModificationDateTime: "",
    };
    user: ApplicationUser;
    locationRequired: boolean = false;

    constructor(
        private readonly sharedService: SharedService,
        private readonly sharedActions: SharedActions,
        private readonly translate: TranslateService,
        private readonly toastr: ToastrService,
        private readonly poolService: PoolService,
        private readonly depotOutActions: DepotOutActions,
        private readonly actionBarService: ActionBarService,
        private readonly modalManager: ModalManagerService,
        private readonly authService: MsalService,
       ) { 
        super()
       } 


       ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }


    public ngOnInit(): void {
        const account = this.authService.getAccount(); 
      this.userId = account.username;

      this.loading$.subscribe((data) => {
        if (!data)
          this.loading = data;
      })
        
        this.applicationUser$.subscribe((user) => {
            if (user !== null) {
                this.user = user;
                this.locationRequired = this.user.generalSetting.locationRequired;
                this.enableAutocomplete = user.generalSetting.enableAutocomplete;
            }
        })

    
    }
    public  ngAfterViewInit() 
    {
        this.depotInSelection$.pipe(takeUntil(this.destroy$)).subscribe((selectedDepotInPlanningBlocks: PlanningBlock[]) => {
            this.depotInSelection = selectedDepotInPlanningBlocks;
        });

        this.depotOutSelection$.pipe(takeUntil(this.destroy$)).subscribe((selectedPlanningBlocks: PlanningBlock[]) => {
            this.selectedPlanningBlocks = selectedPlanningBlocks;
            this.setModalFields(selectedPlanningBlocks);
        });
        this.depotInFrom = new Date().toISOString().slice(0, 10);
        this.containerNumber = null;
        this.containerStatuses$.pipe(takeUntil(this.destroy$)).subscribe((statuses: IdNameAsStringObject[]) => {
            this.statusOptions = statuses;
            this.containerStatuses = statuses;
        });
    }
    
    public ngOnChanges() {
        this.setSelection();
    }
    public setModalFields(selectedPlanningBlocks: PlanningBlock[]) {
        this.updateFormValues(selectedPlanningBlocks);
        this.setSelection();
    }
    public setDateString(date: Date): string {
        let stringDate = "";
        if (date) {
            const allParts = date.toString().split(" ");
            const dateParts = allParts[0].split("/");
            stringDate += dateParts.reverse().join("-") + "T" + allParts[1];
        }
        return stringDate;
    }

    public reverseDateString(stringDate: string): string {
        let apiDate = "";
        if (stringDate) {
            const allParts = stringDate.toString().split("T");
            const dateParts = allParts[0].split("-");
            apiDate += dateParts.reverse().join("/") + " " + allParts[1];
        }
        return apiDate;
    }

    public setButtonState() {
        if (!this.containerNumberRequired) {
            this.containerNumberFilled = true;
        }
        if (this.containerNumberFilled && (this.locationFilled || !this.locationRequired)) {
            this.buttonState = true;
        } else {
            this.buttonState = false;
        }
    }

    public updateFormValues(selectedPlanningBlocks: PlanningBlock[]): void {
        if (this.selectedPlanningBlocks.length > 0) {
            this.selectedPbsStatus = this.selectedPlanningBlocks[0].containerStatus;
            this.getValidStatuses();
                
            this.selectedStatus = this.containerStatuses.find(el => el.name == this.selectedPbsStatus);
            this.containerNumber = null;
            this.setSelection(); 
            if (this.locationSelector) {
            this.locationSelector.setSelectionFromParent(this.selectedPlanningBlocks[0].latestLocationCode);
            this.selectedLocation = this.locationSelector.selectedLocation;
            this.locationFilled = !!this.selectedLocation;
            }
            this.statusEnabled =
                this.selectedPlanningBlocks
                    .every((x) => x.containerStatus === this.selectedPlanningBlocks[0].containerStatus);
            this.enabled = this.selectedPlanningBlocks.length === 1;

            this.commentValue = this.selectedPlanningBlocks.every((x) =>
                x.planningBlockRemarks === this.selectedPlanningBlocks[0].planningBlockRemarks) ?
                this.selectedPlanningBlocks[0].planningBlockRemarks : "";
            this.commentEnabled = this.selectedPlanningBlocks.every((x) =>
                x.planningBlockRemarks === this.selectedPlanningBlocks[0].planningBlockRemarks);

            this.ref1Value = this.selectedPlanningBlocks.length === 1 ?
                this.selectedPlanningBlocks[0].depotOutOrderLineRef1 : "";
            this.ref2Value = this.selectedPlanningBlocks.length === 1 ?
                this.selectedPlanningBlocks[0].depotOutOrderLineRef2 : "";
            this.bookedFromValue = this.selectedPlanningBlocks.length === 1 ?
                this.setDateString(this.selectedPlanningBlocks[0].bookedDatetimeFrom) : "";
            this.bookedUntilValue = this.selectedPlanningBlocks.length === 1 ?
                this.setDateString(this.selectedPlanningBlocks[0].bookedDatetimeUntil) : "";
            this.warehouseRemark = selectedPlanningBlocks.length > 1 ? "" : selectedPlanningBlocks[0].warehouseRemark;
            this.setPlanningStateChange();
            this.locationWasUpdated = false;
            this.setButtonState();
        }
    }

    public setPlanningStateChange(): void {
        /*this.allowPlanningStateChange = (this.selectedPlanningBlocks[0].status.statusType === TO_BE_PLANNED || this.selectedPlanningBlocks[0].status.statusType === ON_HOLD)
            && this.selectedPlanningBlocks.length >= 1;*/

            let firstStatus = this.selectedPlanningBlocks[0].status.statusType; 
            this.allowPlanningStateChange = this.selectedPlanningBlocks.length > 0 
                && this.selectedPlanningBlocks.every((x) => x.status.statusType == firstStatus) 
                && (firstStatus !== RE_USED && firstStatus !== PLANNED );
                if(this.allowPlanningStateChange) {
                    this.selectedPlanningState = this.planningStates.find((elem) => elem.value === this.selectedPlanningBlocks[0].status.statusType);
                } else {
                    this.selectedPlanningState = null;
                }
            
    }

    public setPlanningBlockRemarks(selectedPlanningBlocks: PlanningBlock[]): any {
        if (selectedPlanningBlocks.length === 1) {
            this.commentValue = !this.commentValue ? selectedPlanningBlocks[0].planningBlockRemarks : this.commentValue;
            this.commentEnabled = true;
        } else {
            this.commentValue = selectedPlanningBlocks.every((x) =>
                x.planningBlockRemarks === selectedPlanningBlocks[0].planningBlockRemarks) ?
                selectedPlanningBlocks[0].planningBlockRemarks : "";
            this.commentEnabled = selectedPlanningBlocks.every((x) =>
                x.planningBlockRemarks === selectedPlanningBlocks[0].planningBlockRemarks);
        }
    }

    public onContainerInput(input: string) {
        if (this.selectedPlanningBlocks.length !== 0 && this.selectedPlanningBlocks[0].containerNo !== input && input.length === this.CONTAINER_NUMBER_LENGTH) {
            this.sharedService.checkContainerNumbersInFile(this.selectedPlanningBlocks[0].fileId, input).subscribe((res: boolean) => {
                if (!res) {
                    this.toastr.warning("The file " + this.selectedPlanningBlocks[0].fileId +
                        " already contains a planning block having container number : " + input, "");
                }
            });
        }
        if (this.containerNumber && this.containerNumber.length > 0 && (/\S/.test(input))) {
            this.containerNumberFilled = true;
            this.setButtonState();
        } else if (this.selectedStatus?.id === ContainerStatusId.leegCrea) {
            this.containerNumberFilled = true;
            this.setButtonState();
        } else {
            this.containerNumberFilled = false;
            this.setButtonState();
        }
    }

    public selectionChanged() {
        this.setSelection();
        if (this.selectedStatus?.name === this.selectedPbsStatus) {
            if (this.selectedStatus?.id === ContainerStatusId.leegCrea) {
                this.locationFilled = true;
            } else if (!this.locationSelector.selectedLocation) {
                this.locationFilled = false;
            }
            this.setButtonState();
        } else {
            if (this.locationSelector.selectedLocation
                && this.locationSelector.selectedLocation.searchName.length > 0) {
                this.locationFilled = true;
                this.setButtonState();
            } else {
                if (this.selectedStatus?.id === ContainerStatusId.leegCrea) {
                    this.locationFilled = true;
                } else {
                    this.locationFilled = false;
                }
                this.setButtonState();
            }
        }
    }

    public setSelection() {
        switch (this.selectedStatus?.id) {
            case ContainerStatusId.leegCrea:
                this.containerNumberRequired = true && (this.selectedPlanningBlocks.length === 1);
                this.depotInFromRequired = false;
                if (this.selectedPlanningBlocks.length === 1 && !this.containerNumber) {
                    this.containerNumber = this.selectedPlanningBlocks[0].containerNo;
                    this.onContainerInput(this.containerNumber);
                }
                break;
            case ContainerStatusId.leegAf:
                this.containerNumberRequired = true && (this.selectedPlanningBlocks.length === 1);
                this.depotInFromRequired = false;
                if (this.selectedPlanningBlocks.length === 1 && !this.containerNumber) {
                    this.containerNumber = this.selectedPlanningBlocks[0].containerNo;
                    this.onContainerInput(this.containerNumber);
                }
                break;
            case ContainerStatusId.geladen:
                this.containerNumberRequired = false;
                this.depotInFromRequired = false;
                this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
                break;
            case ContainerStatusId.volKlaar:
                this.containerNumberRequired = false;
                this.depotInFromRequired = false;
                this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
                break;
            case ContainerStatusId.volCrea:
                this.containerNumberRequired = false;
                this.depotInFromRequired = false;
                this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
                break;
            case ContainerStatusId.volAf:
                this.containerNumberRequired = false;
                this.depotInFromRequired = true;
                this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
                break;
            case ContainerStatusId.leegKlaar:
                this.containerNumberRequired = false;
                this.depotInFromRequired = false;
                this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
                break;
            case ContainerStatusId.volIn:
                this.containerNumberRequired = false;
                this.depotInFromRequired = false;
                this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
                break;
            case ContainerStatusId.gelost:
                this.containerNumberRequired = false;
                this.depotInFromRequired = false;
                this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
                break;
            default:
                this.containerNumberRequired = false;
                this.depotInFromRequired = false;
                this.setCurrentContainerNumberToSelectedPlanningBlockContainerNumber();
        }
    }

    public setCurrentContainerNumberToSelectedPlanningBlockContainerNumber(): void {
        if (this.selectedPlanningBlocks.length === 1) {
            this.containerNumber = this.selectedPlanningBlocks[0].containerNo;
        }
    }

    public getValidStatuses() {
        if (this.selectedPbsStatus) {
            this.sharedService
                .getValidContainerStatuses(this.selectedPlanningBlocks[0].orderNumber, this.selectedPbsStatus)
                .subscribe((data: string[]) => {
                    if (this.selectedPlanningBlocks[0]) {
                        data.push(this.selectedPlanningBlocks[0].containerStatus);
                        let array = this.containerStatuses.filter(status => data.find(el => el == status.name));
                        this.statusOptions = array;
                    }
                });
        }
    }

    public enableUi() {
        this.allowPlanningStateChange = false;
        this.setModalFields(this.selectedPlanningBlocks);
        this.sharedActions.setUiState(true);
        //this.modalManager.closeModal(this.modalType.status);
        this.close() ; 
    }

    public getSelectedLocation(location: AddressLocation) {
        if (location) {
            if (this.selectedLocation !== location) {
                this.locationWasUpdated = true;
            }
            this.selectedLocation = location;
            if (this.locationSelector.selectedLocation &&
                this.locationSelector.selectedLocation.searchName.length > 0) {
                this.locationFilled = true;
            } else {
                this.locationFilled = false;
            }
        } else {
            this.locationSelector.setSelectionFromParent("empty");
            this.selectedLocation = null;
            this.locationFilled = false;
        }
        this.setButtonState();
    }

    public clearLocation() {
        this.selectedLocation = null;
        this.locationSelector.setSelectionFromParent("empty");
        this.selectionChanged();
        this.setButtonState();
    }

    public updater() {
        if (this.containerNumberRequired && this.containerNumber && this.containerNumber.length !== 0) {
            this.checkContainerNumber();
        } else {
            this.updateDataNew(false);
        }
    }

    public checkContainerNumber() {

        this.sharedService.checkContainerNumberCpl(this.containerNumber, this.userId).subscribe((res) => {
            if (res.statusCode === "OK") {
                this.containerNumberIsValid = true;
                if (this.selectedPlanningBlocks[0].containerNo !== this.containerNumber) {
                    this.checkContainerAvailability(this.selectedPlanningBlocks[0].id, this.containerNumber);
                } else {
                    this.updateDataNew(false);
                }
            }
        },
            (err) => {
                const description = err.feedback[0].description;
                this.containerNumberIsValid = false;
                this.buttonState = false;
                this.containerIsAvailable = false;
                this.translate.get("STATUS_MODAL.ERROR_PANEL.ERROR_TEXT").subscribe((res: string) => {
                    this.containerNumberErrorMessage = description + " " + res;
                });
            });

    }

    public checkContainerAvailability(pbId: number, containerNumber: string) {
        this.containerNumberIsValid = true;
        this.poolService.checkContainerAvailability(this.selectedPlanningBlocks[0].id, this.containerNumber, this.userId)
            .subscribe((available: boolean) => {
                if (available) {
                    if (this.selectedStatus?.id === ContainerStatusId.leegCrea) {
                        this.translate.get("TOASTR_MESSAGES.ERROR.UPDATE_WRONG_STATUS").subscribe((res: string) => {
                            this.toastr.error("ERROR: " + res);
                        });
                    } else {
                        this.containerIsAvailable = true;
                    }

                } else {
                    // false: the user can carry on the normal function (update or plan)
                    this.buttonState = true;
                    this.updateDataNew(false);
                }
            }, (err) => {
                // display error , the user will have to type another c number
                this.buttonState = false;
                this.containerIsAvailable = false;
            });
    }

    public moveContainerOutOfPool() {
        this.poolService.registerApprovePoolContReqChecks([this.selectedPlanningBlocks[0].id], this.userId).subscribe(() => {
            this.updateDataNew(true);

           /* if(this.selectedStatus === this.containerStatus.leegAf) {
                this.sharedService.containerInOutPool([this.selectedPlanningBlocks[0].id],this.selectedCapacity.id,this.selectedStatus,
                    this.selectedLocation, this.userId, this.selectedPlanningBlocks[0].depotInRef1, this.selectedPlanningBlocks[0].depotOutRef1).subscribe((data) => {
                        this.sharedActions.updatePlanningBlocksDisplay([...data]);
                    });
            }*/
        }, (err) => {
            // display error , the user will have to type another c number
            this.buttonState = true;
            this.containerIsAvailable = false;
        });

        

    }

    public updateDataNew(isMoveContainerOutOfPool: boolean) {
        this.loading = true;
        const toUpdatePlanningBlocks = this.selectedPlanningBlocks;
        const promises = [];

        toUpdatePlanningBlocks.forEach((planningBlock: PlanningBlock) => {
            promises.push(this.updatePlanningBlock(planningBlock, isMoveContainerOutOfPool, toUpdatePlanningBlocks.length,
                this.userId));
        });

        Promise.all(promises).then(() => {
            this.translate.get("TOASTR_MESSAGES.SUCCESS.STATUS_UPDATE_SUCCEEDED").subscribe((res: string) => {
                this.toastr.success(res, "", {
                    closeButton: false
                });
            });
            this.resetUi();
            this.loading = false;
            this.containerIsAvailable = false;
            this.sharedActions.setUiState(true);
        });
    }

    public updatePlanningBlock(planningBlock: PlanningBlock, isMoveContainerOutOfPool: boolean, numberOfPlanningBlocks: number,
        username: string): Promise<boolean> {
        return new Promise<boolean>((resolve) => {


            const updatePlanningBlockViewModel =
                this.getUpdatePlanningBlockViewModel(planningBlock, isMoveContainerOutOfPool, username);

            updatePlanningBlockViewModel.containerNumber.value = numberOfPlanningBlocks > 1
                ? planningBlock.containerNo : this.containerNumber;
            updatePlanningBlockViewModel.planningBlockRemark.value = numberOfPlanningBlocks > 1 && !this.commentEnabled
                ? planningBlock.planningBlockRemarks : this.commentValue;
            updatePlanningBlockViewModel.status = this.selectedPlanningState ? this.selectedPlanningState.value : -1;

            this.sharedService.updatePlanningBlockCpl(updatePlanningBlockViewModel)
                .subscribe((updatedPlanningBlocks: PlanningBlock) => {
                    planningBlock.depotInFrom = this.formatDateForApi();
                    planningBlock.containerNo = this.containerNumber;
                    this.buttonState = true;
                    this.containerIsAvailable = false;
                    planningBlock.planningBlockRemarks = this.commentValue;
                    planningBlock.depotOutOrderLineRef1 = this.ref1Value;
                    planningBlock.depotOutOrderLineRef2 = this.ref2Value;
                    planningBlock.bookedDatetimeFrom = new Date(this.bookedFromValue);
                    planningBlock.bookedDatetimeUntil = new Date(this.bookedUntilValue);
                    this.sharedActions.updatePlanningBlocksDisplayCpl([updatedPlanningBlocks]);

                    return resolve(true);
                }, (err) => {
                    return resolve(false);
                });


        });
    }

    public getUpdatePlanningBlockViewModel(planningBlock: PlanningBlock,
        isMoveContainerOutOfPool: boolean,
        userId: string): UpdatePlanningBlock {
        let status: any;
        let location: any;

        if (this.statusEnabled) {
            status = this.selectedStatus?.name;
        } else {
            status = planningBlock.containerStatus;
        }

        if (!this.selectedLocation){
            location = this.emptyLocation;
        } else {
            location = this.selectedLocation;
        }

        const updatePlanningBlock = {
            id: planningBlock.id,
            userId,
            bookedDates: {
                fromDateString: this.reverseDateString(this.bookedFromValue),
                untilDateString: this.reverseDateString(this.bookedUntilValue),
            },
            containerNumber: {
                value: this.containerNumber === null ? "" : this.containerNumber,
            },
            depotInDate: {
                value: this.formatDateForApi(),
            },
            depotOutReference: {
                type: 0,
                value: this.ref1Value,
            },
            depotOutReference2: {
                type: 1,
                value: this.ref2Value,
            },
            depotInReference: {
                type: 0,
                value: "",
            },
            depotInReference2: {
                type: 1,
                value: "",
            },
            status: this.selectedPlanningState ? this.selectedPlanningState.value : "",
            updateStatus: {
                addressLocation: location,
                status,
            },
            planningBlockRemark: {
                value: this.commentValue,
                remarkType: 5,
                orderId: "",
            },
            isMoveContainerOutOfPool,
            containerReuseNo: planningBlock.containerReuseNo,
            containerPoolRequestNo: planningBlock.containerPoolRequestNo,
        };

        return updatePlanningBlock;
    }

    public resetUi() {
        this.loading = false;
        this.setModalFields(this.selectedPlanningBlocks);
        this.depotOutActions.setDepotOutSelection([]);
        this.actionBarService.setActionBar(this.depotInSelection, [], ComponentSource.depotOut);
        this.sharedActions.setUiState(true);
        //this.modalManager.closeModal(this.modalType.status);
        this.close () ; 
    }
    public resetContainerNumber() {
        this.containerNumber = null;
        this.containerNumberIsValid = true;
        this.containerNumberFilled = false;
        this.buttonState = false;
        this.containerIsAvailable = false;
    }

    public formatDateForApi() {
        const dateArray = this.depotInFrom.split("-");
        const apiFormattedDate = dateArray[1] + "-" + dateArray[2] + "-" + dateArray[0];
        return apiFormattedDate;
    }

    private getSelectedCapacity(capacity) {
        if (capacity) {
          this.selectedCapacity = capacity;
        }
    }
    private validateCapacity(): boolean {
        return !this.selectedCapacity;
    }
    private getSelectedPlanDate(planDate) {
        this.planDate = planDate;
    }
}
